import { render, staticRenderFns } from "./espMovil.vue?vue&type=template&id=cf1f9850"
import script from "./espMovil.vue?vue&type=script&lang=js"
export * from "./espMovil.vue?vue&type=script&lang=js"
import style0 from "./espMovil.vue?vue&type=style&index=0&id=cf1f9850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports